import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { createValidationSchemas } from "../../schemas/user.schema";
import Button from "../Button/Button";
import Input from "../input/Input";
import { authService } from "../../services/auth.service";
import { toast } from "react-hot-toast";
import GoogleLoginButton from "../googlebutton/googleLogin";
import Cookies from "js-cookie";
import { profileUpdate } from "../../redux/slices/userSlice";
import axios from "axios";
import { useGoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import { HttpService } from "../../services/base.service";
// import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { timeZoneCityToCountry } from "../../services/countries";
import { useTranslation } from "react-i18next";
import { generateSecureToken } from "../../utils/navigateEditor";

const SignupModal = ({ setstate1, setPopup }) => {
  const [state, setstate] = useState(true);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  // const { executeRecaptcha } = useGoogleReCaptcha();
  const { t, i18n } = useTranslation();
  const validationSchemas = createValidationSchemas(t);

  const formik = useFormik({
    initialValues: {
      fullName: "",
      password: "",
      email: "",
    },
    validationSchema: validationSchemas.validateSignupForm,
    validateOnChange: true,
    onSubmit: async (values) => {
      try {
        setLoading(true);

        // if (!executeRecaptcha) {
        //   toast.error("Error occur while submitting form");
        //   setLoading(false);
        //   return;
        // }

        const token = generateSecureToken();

        if (!token) {
          toast.error("Error occur while submitting form");
          setLoading(false);
          return;
        }

        let obj = { token, ...values };
        obj["email"] = obj?.email.toLowerCase();
        obj["country"] = await getCountry();
        obj["platform"] = "web";

        const user = await authService.signup(obj);
        if (user?.status === 200 || user?.status === 201) {
          toast.success(user?.data?.message);
          Cookies.set("session_id", user?.data?.data?.access_token, {
            domain: process.env.REACT_APP_PUBLIC_DOMAIN,
            path: "/",
          });
          Cookies.set("device_id", user?.data?.data?.device_id, {
            domain: process.env.REACT_APP_PUBLIC_DOMAIN,
            path: "/",
          });
          HttpService.setToken(user?.data?.data?.access_token);
          setLoading(false);
          const obj = {
            status: user.data.status,
            success: user.data.success,
            message: user.data.message,
            data: user.data.data.profile,
          };
          dispatch(profileUpdate(obj));
          setLoading(false);
          setstate1(-1);
          setPopup(false);
        }
      } catch (error) {
        console.log(error.data);
        setLoading(false);
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        } else {
          console.log(error.response);
        }
      }
    },
  });

  const getCountry = async () => {
    try {
      var userRegion;
      var userCity;
      var userCountry;
      var userTimeZone;

      if (Intl) {
        userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        var tzArr = userTimeZone.split("/");
        userRegion = tzArr[0];
        userCity = tzArr[tzArr.length - 1];
        //@ts-ignore
        userCountry = timeZoneCityToCountry[userCity];
      }

      return userCountry;
    } catch (error) {
      return "";
    }
  };

  const googleAuthenticationHandler = useGoogleLogin({
    onSuccess: async (response) => {
      try {
        setLoading(true);
        const country = await getCountry();

        authService
          .socialLogin({
            access_token: response.access_token,
            country: country,
            platform: "web",
            provider: "google",
            device_id: Cookies.get("device_id"),
          })
          .then((user) => {
            if (user.status === 200) {
              Cookies.set("session_id", user?.data?.data?.access_token, {
                domain: process.env.REACT_APP_PUBLIC_DOMAIN,
                path: "/",
              });
              Cookies.set("device_id", user?.data?.data?.device_id, {
                domain: process.env.REACT_APP_PUBLIC_DOMAIN,
                path: "/",
              });
              HttpService.setToken(user?.data?.data?.access_token);
              dispatch(profileUpdate(user.data));
              setLoading(false);
              setstate1(-1);
              setPopup(false);
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(error?.response?.data?.message);
          });

        // console.log(res);
      } catch (error) {
        toast.error(t("Login Failed"));
        console.log("Login Failed", error);
      }
    },
    onError: (error) => {
      toast.error(t("Login Failed"));
      console.log("Login Failed", error);
    },
  });

  useEffect(() => {
    const firstInput = document.getElementById("fullName");
    firstInput.focus();
    firstInput.select();
  }, []);
  return (
    <div className="flex flex-col md:gap-8 gap-4 w-full">
      <div>
        <h3 className="modal-heading mb-1">{t("Create a new account")}</h3>
        <p className="modal-description !text-base">
          {t("Get started - it's free. No credit card needed.")}
        </p>
      </div>
      <form action="" onSubmit={formik.handleSubmit}>
        <div className="mb-3">
          <Input
            id="fullName"
            placeholder={t("Full Name")}
            name="fullName"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.fullName}
            error={formik.errors.fullName}
          />
        </div>
        <div className="mb-3">
          <Input
            placeholder={t("Enter your email")}
            name="email"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            error={formik.errors.email}
          />
        </div>
        <div className="mb-8">
          <div className="relative">
            <Input
              placeholder={t("Enter your password")}
              type={state ? "password" : "text"}
              name="password"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.password}
            />
          </div>
          {formik.touched.password && formik.errors.password && (
            <ul className="at-error list-disc list-inside text-red-700 mt-1 text-left text-sm">
              <li>{t("Have at least 1 uppercase")}</li>
              <li>{t("Have at least 1 special character")}</li>
              <li>{t("Have at least 1 number")}</li>
              <li>{t("Have at least 8 characters")}</li>
            </ul>
          )}
        </div>

        <Button
          type="submit"
          isLoading={loading}
          disabled={!formik.isValid || !formik.dirty || loading}
          value={t("Sign up")}
          className="mb-10 w-full"
        />
        <div className="flex items-center gap-4 justify-center my-8">
          <div className="w-full h-[1px] bg-secondary-10"></div>
          <p className="text-secondary-500 text-sm text-center flex-shrink-0">
            {t("or continue with")}
          </p>
          <div className="w-full h-[1px] bg-secondary-10"></div>
        </div>
        <div className="flex gap-5 justify-center mb-6">
          {/* <i className="icon-facebook text-[1.625rem] py-4 px-6 border border-[#D3D3D3] rounded-[14px] text-primary"></i> */}
          <GoogleLoginButton
            handleGoogleLogin={googleAuthenticationHandler}
          />
        </div>
        <p className="text-center text-secondary-1000 text-sm">
          {t("Already have an account?")}{" "}
          <span
            className="text-primary cursor-pointer"
            onClick={() => {
              setstate1(1);
            }}
          >
            {t("Log in")}
          </span>{" "}
        </p>
      </form>
    </div>
  );
};

export default SignupModal;
